// extracted by mini-css-extract-plugin
export default {"PopoverContent":"CopilotPopover-module__PopoverContent--vIHIX"};